import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const KJRapportMeny: IRapportInfo[] = [];

export default KJRapportMeny;
